import Button from "~/shared/ui/Fields/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import s from "./ControlButtons.less";
import clsx from "clsx";
import { useGetLocationData } from "~/hooks/locationData";

const ControlButtons = (props) => {
  const {
    setIsEditCourse,
    setIsMoreDetails,
    handleDeleteCourse,
    course,
    isMoreDetails,
    handleShowMoreDetails,
    handleOpenModal,
  } = props;

  const { t } = useTranslation();
  const { openType } = useGetLocationData();
  const isView = openType === "View";
  const isEdit = openType === "Edit";

  const handleEditCourse = () => {
    setIsEditCourse(true);
    setIsMoreDetails(false);
    handleOpenModal();
  };
  return (
    <>
      {!isView && (
        <>
          <Button
            small={true}
            txtBtn={t("ui.edit")}
            onClick={handleEditCourse}
          />
          {!isEdit && (
            <Button
              small={true}
              txtBtn={t("ui.delete")}
              onClick={() => handleDeleteCourse(course)}
            />
          )}
        </>
      )}
      <div
        className={clsx(s.more_button, isMoreDetails ? s.active : null)}
        onClick={handleShowMoreDetails}
      >
        <span>{!isMoreDetails ? ">" : "<"}</span>
      </div>
    </>
  );
};

export default ControlButtons;
